import React from "react";
import { TbBellRinging } from "react-icons/tb";
import { getUserData } from "../utils/authStorage";

const HeaderNav = ({ profileIcon, companyName }) => {
  const userData = getUserData();
  const displayName = companyName || userData?.customer?.company_name || "";
  const initial = displayName.charAt(0).toUpperCase();
  return (
    <header className="mobile-header-new">
      <div className="greeting-block">
        <div className="mobile-avatar-initial">{initial}</div>
        <div className="greeting-text">
          <p className="hello-text">Hi,</p>
          <h3 className="company-text">{displayName}</h3>
        </div>
      </div>

      <div className="notification-wrapper">
        <TbBellRinging size={25} color="black" />
        <span className="notification-dot" />
      </div>
    </header>
  );
};

export default HeaderNav;